import { MyCommunitiesQuickFilterType } from 'types/recommendations';

export const MY_COMMUNITIES_QUICK_FILTER_ALL: MyCommunitiesQuickFilterType = 'all';
export const MY_COMMUNITIES_QUICK_FILTER_NEEDS_ATTENTION: MyCommunitiesQuickFilterType = 'needs_attention';
export const MY_COMMUNITIES_QUICK_FILTER_NOTABLE_RATE_GAP: MyCommunitiesQuickFilterType = 'notable_rate_gap';
export const MY_COMMUNITIES_QUICK_FILTER_NEGATIVE_REVIEWS: MyCommunitiesQuickFilterType = 'negative_reviews';
export const MY_COMMUNITIES_QUICK_FILTER_NEW_COMPETITOR_INCENTIVES: MyCommunitiesQuickFilterType =
  'new_competitor_incentives';
export const MY_COMMUNITIES_QUICK_FILTER_ACTION_PLAN_STALLED: MyCommunitiesQuickFilterType = 'action_plan_stalled';

export const MY_COMMUNITIES_QUICK_FILTER_ORDER: MyCommunitiesQuickFilterType[] = [
  MY_COMMUNITIES_QUICK_FILTER_ALL,
  MY_COMMUNITIES_QUICK_FILTER_NEEDS_ATTENTION,
  MY_COMMUNITIES_QUICK_FILTER_NOTABLE_RATE_GAP,
  MY_COMMUNITIES_QUICK_FILTER_NEGATIVE_REVIEWS,
  MY_COMMUNITIES_QUICK_FILTER_NEW_COMPETITOR_INCENTIVES,
];

export const MY_COMMUNITIES_QUICK_FILTER_LABEL: Record<MyCommunitiesQuickFilterType, string> = {
  all: 'All',
  needs_attention: 'Needs Attention',
  notable_rate_gap: 'Notable Rate Gap',
  negative_reviews: 'Recent Reviews',
  new_competitor_incentives: 'Recent Competitor Incentives',
  action_plan_stalled: 'Action Plan Stalled',
};

export const MY_COMMUNITIES_TIME_PERIOD_OPTIONS = [
  { value: 7, label: 'Last 7 Days' },
  { value: 30, label: 'Last 30 Days' },
  { value: 90, label: 'Last 90 Days' },
];

export const MY_COMMUNITIES_DEFAULT_TIME_PERIOD_DAYS = 30;

export const MIN_COMPETITORS_FOR_AVERAGE = 2;

export const getCompetitorComparisonLabel = (competitorCount: number) =>
  competitorCount >= MIN_COMPETITORS_FOR_AVERAGE ? 'vs competitor avg' : 'vs 1 competitor';

export const MY_COMMUNITIES_RATE_GAP_THRESHOLD_OPTIONS = [
  { value: 20, label: '±20%' },
  { value: 25, label: '±25%' },
  { value: 30, label: '±30%' },
  { value: 35, label: '±35%' },
  { value: 40, label: '±40%' },
  { value: 45, label: '±45%' },
  { value: 50, label: '±50%' },
];

export const MY_COMMUNITIES_DEFAULT_RATE_GAP_THRESHOLD_PERCENT = 35;

export const MY_COMMUNITIES_COLUMN_WIDTH = {
  COMMUNITY: 260,
  SCORE: 170,
  RANK: 190,
  RATE_GAP: 240,
  REVIEWS: 140,
  COMPETITOR_INCENTIVES: 170,
  DETAILS: 130,
} as const;

export const MY_COMMUNITIES_ORDERING = {
  COMMUNITY_NAME: 'community_name',
  SCORE: 'score',
  RANK: 'rank',
  RATE_GAP: 'rate_gap',
  REVIEWS_AVERAGE: 'reviews_average',
  NEW_COMPETITOR_INCENTIVES: 'new_competitor_incentives_count',
} as const;
